import { render, staticRenderFns } from "./TableDataManagement.vue?vue&type=template&id=3b810790&"
import script from "./TableDataManagement.vue?vue&type=script&lang=js&"
export * from "./TableDataManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports